export const VOUCHER_REDEMPTION_CLAIM_ACTION = 'VOUCHER_REDEMPTION_CLAIM_ACTION'
export const VOUCHER_REDEMPTION_CLAIM_ACTION_SUCCESS = 'VOUCHER_REDEMPTION_CLAIM_ACTION_SUCCESS'
export const VOUCHER_REDEMPTION_CLAIM_ERROR_ACTION = 'VOUCHER_REDEMPTION_CLAIM_ERROR_ACTION'

